import React from "react";
import { C, getTheme } from "../theme";

const DEFAULT_TABS = [
  { id: "dashboard", icon: "◈", label: "Prep Dashboard" },
  { id: "recording", icon: "●", label: "Live Recording" },
  { id: "report", icon: "◎", label: "Trip Report" },
  { id: "patterns", icon: "◉", label: "Patterns" },
];

export default function BottomNav({ active, onNavigate, disabledTargets = [], tabs = DEFAULT_TABS }) {
  const isDark = getTheme() === "dark";
  // Dark mode: lighten inactive icons for readability and use a distinct
  // highlight color for the active tab so it reads differently from the rest.
  const activeColor = isDark ? C.gold : C.accent;
  const inactiveColor = isDark ? C.sand : C.muted;
  const inactiveOpacity = isDark ? 0.7 : 0.4;
  return (
    <div
      style={{
        position: "absolute",
        bottom: "max(3px, env(safe-area-inset-bottom, 0px))",
        left: 3,
        right: 3,
        height: 54,
        background: C.midnight,
        borderTop: `1px solid ${C.border}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-around",
        zIndex: 10,
        borderBottomLeftRadius: 18,
        borderBottomRightRadius: 18,
        overflow: "hidden",
      }}
    >
      {tabs.map((t) => {
        const isDisabled = disabledTargets.includes(t.id);
        const isLink = t.type === "link" && !!t.href;
        const isActive = active === t.id;
        const tone = isDisabled
          ? C.muted
          : isActive
          ? activeColor
          : inactiveColor;
        const containerStyle = {
          background: "none",
          border: "none",
          cursor: isDisabled ? "default" : "pointer",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 1,
          opacity: isDisabled ? 0.2 : isActive ? 1 : inactiveOpacity,
          transition: "opacity 0.2s",
          padding: "3px 4px 2px",
          minWidth: 0,
          flex: 1,
          textDecoration: "none",
        };
        const inner = (
          <>
            <span style={{ position: "relative", fontSize: 14, color: tone, lineHeight: 1, display: "inline-flex" }}>
              {t.icon}
              {!isDisabled && t.badge > 0 && (
                <span
                  style={{
                    position: "absolute",
                    top: -5,
                    right: -9,
                    minWidth: 14,
                    height: 14,
                    padding: "0 3px",
                    borderRadius: 999,
                    background: C.accent,
                    color: "#FFFFFF",
                    fontSize: 8,
                    fontWeight: 700,
                    lineHeight: "14px",
                    textAlign: "center",
                    boxShadow: `0 0 0 1.5px ${C.midnight}`,
                  }}
                >
                  {t.badge > 99 ? "99+" : t.badge}
                </span>
              )}
            </span>
            <span
              style={{
                fontSize: 8,
                color: tone,
                letterSpacing: 0.35,
                textAlign: "center",
                lineHeight: 1.1,
              }}
            >
              {t.label}
            </span>
          </>
        );

        if (isLink) {
          return (
            <a
              key={t.id}
              id={`bottom-nav-${t.id}`}
              data-testid={`bottom-nav-${t.id}`}
              href={t.href}
              title={t.label}
              aria-label={t.label}
              style={containerStyle}
            >
              {inner}
            </a>
          );
        }

        return (
          <button
            key={t.id}
            id={`bottom-nav-${t.id}`}
            data-testid={`bottom-nav-${t.id}`}
            onClick={() => {
              if (isDisabled) return;
              onNavigate(t.id);
            }}
            disabled={isDisabled}
            type="button"
            style={containerStyle}
          >
            {inner}
          </button>
        );
      })}
    </div>
  );
}
